import { Flex, FormLabel, Switch } from "@chakra-ui/react";
import { FormikValues, useFormikContext } from "formik";
import { get } from "lodash";

interface SwitchFieldProps {
  name: string;
  label: string;
}

function SwitchField<Value extends FormikValues>({
  name,
  label,
  ...props
}: SwitchFieldProps) {
  const { handleChange, values } = useFormikContext<Value>();
  return (
    <Flex gap="10px" align="center">
      <Switch
        {...props}
        id={name}
        isChecked={get(values, name, false)}
        onChange={handleChange}
      />
      <FormLabel
        htmlFor={name}
        mb={0}
        fontSize="13px"
        fontWeight="500"
        color="#14171C"
        cursor="pointer"
      >
        {label}
      </FormLabel>
    </Flex>
  );
}
export default SwitchField;
